<style lang="less" scoped>
@import "~assets/less/icon.less";
.wrapper{
    padding:50px 30px;
    .banner{
        .banner-text{
            font-size: 26px;
            color:#42415A;
            line-height: 1.5;
        }
    }
    .container{
        background:#FFFFFF;
        border-radius: 30px;
        padding:30px;
        width: 630px;
        margin:50px auto 0 auto;
        .audit-count{
            width: 240px;
            height:240px;
            margin:0 auto 15px auto;
            background:url("../../assets/images/audit/aduit1.png") no-repeat;
            background-size:100% 100%;
        }
        .btn{
          background:#09BA86;
          width: 324px;
          height:80px;
          display: flex;
          justify-content: center;
          align-items: center; 
          margin:0 auto;
          .icon{
            margin-right: 10px;
          }
          .btn-text{
            font-size: 36px;
            color:#fff;
          }
        }
        .promot-amount{
            background:url("../../assets/images/audit/audit2.png") no-repeat;
            background-size:100% 100%;
            width: 564px;
            height:350px;
            margin:20px auto 0 auto;
        }
    }
}
</style>
<template>
    <div class="wrapper">
        <div class="banner">            
            <p class="banner-text">
                1. It will take a few minutes for assessing your information.
            </p>
            <p class="banner-text">
                2. We will notice you the result for application via message, thanks for your patient.
            </p>
        </div>
        <!-- <div class="btn-container">
            <a class="btn-submit" @click.prevent="update">Update Status</a>
        </div> -->
        <div class="placeholder"></div>
        <div class="container">
            <div class="audit-count"></div>
            <div class="btn">
                <i class="icon icon-refresh"></i>
                <span class="btn-text" @click="update">Refresh</span>
            </div>
        </div>
        <div class="container">
            <div class="promot-amount"></div>
        </div>
    </div>
</template>
<script>
import { orderDetail } from "@api/index";
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { useLoading } from 'vue-loading-overlay'
export default {
    setup () {
        const router = useRouter()
        const route = router.currentRoute.value
        const loading = useLoading()
        const clicked = ref(false)
        onMounted(()=>{
            // const loader = loading.show({
            //     container:null
            // })
            // setTimeout(()=>{
            //     loader.hide()
            // },1000)
        })
        const update = () => {    
            if(clicked.value)return
            clicked.value = true
            const loader = loading.show({
                container: null
            })
            orderDetail({
                orderId:route.params.id
            }).then((res)=>{
                loader.hide()
                clicked.value = false
                if(res.code == 0) {                    
                    if(res.data.orderState == 2) {
                        router.replace({
                            path:`/orders/${res.data.orderId}/confirm`
                        })
                    } else if (res.data.orderState >= 4) {
                        router.replace({
                            path:'/order'
                        })
                    }
                }
            })
        }
        return {
            update
        }
    }
}
</script>
